import { useState } from "react"
import { useDispatch } from 'react-redux'

//reducers
import { setRole } from '../../../reducers/playerReducer'

import Player_Myyja2 from '../../../images/svg/Player_Myyja2.svg'
import Player_Vastaaja2 from '../../../images/svg/Player_Vastaaja2.svg'

import './SelectRole.css'

const SelectRole = ({ nextPage }) => {
    const [localRole, setLocalRole] = useState('')
    const [sellerStyle, setSellerStyle] = useState('')
    const [customerStyle, setCustomerStyle] = useState('')

    const dispatch = useDispatch()

    
    const removeHover = (StyleRole) => {
        switch (StyleRole) {
            case 'seller':
                if (localRole !== 'seller') {
                    setSellerStyle('')
                }
                break;
            case 'customer':
                if (localRole !== 'customer') {
                    setCustomerStyle('')
                }
                break;
            default:
                break;
        }
    }
    

    const updateRole = (newRole) => {
        //TODO soita ääni

        /*
        if (newRole === 'seller') {
            setCustomerStyle('')
        } else {
            setSellerStyle('')
        }
        */

        setLocalRole(newRole)
        dispatch(setRole(newRole))
        nextPage()
    }

    return (
        <div className='select-role-container'>
            <div className='extra-space' >Valitse roolisi</div>
            <div className={`player-selection-button extra-space 
                    ${localRole === 'seller' && 'hover'} ${sellerStyle}`}
                onMouseEnter={() => setSellerStyle('hover')}
                onMouseLeave={() => removeHover('seller')}
                onClick={() => updateRole('seller')}>
                <img src={Player_Myyja2} className={`player-select-${sellerStyle}`} alt="valitse puhelinmyyjä" />
                Puhelinmyyjä
            </div>
            <div className={`player-selection-button
                    ${localRole === 'customer' && 'hover'} ${customerStyle}`}
                onMouseEnter={() => setCustomerStyle('hover')}
                onMouseLeave={() => removeHover('customer')}
                onClick={() => updateRole('customer')}>
                <img src={Player_Vastaaja2} className={`player-select-${customerStyle}`} alt="valitse vastaaja" />
                Asiakas
            </div>
        </div>
    )
}

export default SelectRole